module.exports = __webpack_public_path__ + "static/media/what-we-do-2.4beb6ae3.png";